import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import UserMenuApp from './UserMenuApp';
import { BrowserRouter } from 'react-router-dom';

// Główna aplikacja (wyceniarka)
const mainAppElement = document.getElementById('root');
if (mainAppElement) {
    const root = ReactDOM.createRoot(mainAppElement);
    root.render(
        <BrowserRouter basename="/">
        <App />
        </BrowserRouter>
    );
}

// Menu użytkownika (dla shortcode)
document.addEventListener('DOMContentLoaded', () => {
    const userMenuElements = document.querySelectorAll('[data-react-user-menu]');
    userMenuElements.forEach(element => {
        const root = ReactDOM.createRoot(element);
        root.render(<UserMenuApp />);
    });
});
